import React from "react";
import { BrowserRouter } from "react-router-dom";
export var Router = function (_a) {
    var children = _a.children;
    return (React.createElement(BrowserRouter, null, children));
};
